var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isEmpty)?_c('div',{class:_vm._.recommend,style:({
    marginTop: (_vm.topRem + "rem"),
    visibility: _vm.visible ? 'visible' : 'hidden',
  })},[_c('div',{class:_vm._.hd},[_c('x-icon',{class:_vm._.icon,attrs:{"src":require('./images/猜你喜欢.png')}}),_c('div',{class:_vm._.title},[_vm._v("人气精选")])],1),_c('x-goods-waterfall',{class:_vm._.list,attrs:{"load":_vm.loadData,"track":{
      from: '猜你喜欢',
    },"disabled":true}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }